import {RequestForm_FieldTreatAs, RequestFormFieldType} from "./const/const";
import {FieldType} from "../../../core/fields3/field-type";

export enum MandatoryFieldsIds {
    NAME    = 'request-user-name',
    EMAIL   = 'request-user-email',
    TITLE   = 'title'               // same as task field id
}

export const PublicRequestFrom_FieldName = {
    type            : RequestFormFieldType.FORM,
    formFieldConfig : {
        fieldId : MandatoryFieldsIds.NAME,
        type    : FieldType.STRING,
    },
    label           : 'Your name',
    description     : '',
    isRequired      : true,
    // isMandatory     : true,
    treatAs         : RequestForm_FieldTreatAs.USER_NAME
}

export const PublicRequestFrom_FieldEmail = {
    type            : RequestFormFieldType.FORM,
    formFieldConfig : {
        fieldId : MandatoryFieldsIds.EMAIL,
        type    : FieldType.EMAIL,
    },
    label           : 'Your email address',
    description     : '',
    isRequired      : true,
    // isMandatory     : true,
    treatAs         : RequestForm_FieldTreatAs.USER_EMAIL
}

export const PublicRequestFrom_FieldTitle = {
    type        : RequestFormFieldType.TASK,
    taskFieldId : MandatoryFieldsIds.TITLE,
    label       : 'Title',
    description : '',
    isRequired  : true,
    isMandatory : true,
}